module.exports = __webpack_public_path__ + "static/img/cashWheelIndexIcon.2e97298.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/cashWheelIndexIcon.gif
// module id = zHai
// module chunks = 0